<template>
  <div class="bulkcoupon secondary_title">
    <!-- 默认样式 -->
    <div v-if="(bulk_coupon.show_message && bulk_coupon.show_message.show_type === 'default') || !bulk_coupon.show_message">
      <h4 class="secondary_title">{{$t('detail.buy_more_save_more')}}</h4>
      <div class="bulkBody">
        <div class="couponItem" v-for="(item, index) in bulk_coupon.discount_rule" :key="item.from">
          <div class="couponTips">
            <h5 class="page_text_font" v-if="preference_type=='amount'">
              {{$t('product.bulk_coupon_amount',{value:`${priceSymbol}${computePrice(item.from,false,false,'auto')}`,off:item.type == 'flat'?`${priceSymbol}${ computePrice(item.value,false,false,'auto') }`:`${ item.value}%`})}}
            </h5>
            <h5 class="page_text_font" v-else-if="preference_type=='step'">
              {{ stepTip(item) }}
            </h5>
            <h5 class="page_text_font" v-else>
              {{$t('product.bulk_coupon_count',{count:item.from,off:item.type == 'flat'?`${priceSymbol}${ computePrice(item.value,false,false,'auto') }`:`${ item.value}%`})}}
            </h5>
            <p class="page_text_font" v-if="preference_type != 'step'">{{$t('detail.on_each_product')}}</p>
          </div>
          <div class="couponButton" v-if="preference_type !='amount' && ((bulk_coupon.show_message && bulk_coupon.show_message.show_cart) || !bulk_coupon.show_message)">
            <div
              class="addToCart"
              :class="theme == 'vogue'? 'text-uppercase':''"
              :style="{
                color: mainButtonColor,
                borderColor: mainButtonColor,
                backgroundColor: 'transparent',
              }"
              v-if="item.from <= cart_contents_count"
              style="opacity: 0.5; "
            >
              <span class="iconfont icon-cm-duigou"></span>
              {{$t('detail.added')}}
            </div>
            <button
              class="addToCart secondary_title"
              :class="{ button_active: disabled }"
              :style="{
                color: mainButtonColor,
                borderColor: mainButtonColor,
                backgroundColor: 'transparent',
              }"
              :disabled="disabled"
              v-if="(item.from > cart_contents_count)&&stock"
              v-show="!disabled || click_index == index"
              @click.prevent="addToCart(item.from, index)"
            >{{$t('detail.add_to_cart')}}</button>
            <button
              class="addToCart soldout secondary_title"
              style="opacity:0.6"
              :disabled="true"
              v-else-if="item.from > cart_contents_count&&!stock"
              v-show="!disabled || click_index == index"
              @click.prevent="addToCart(item.from, index)"
            >{{$t('detail.sold_out')}}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 表格样式 -->
    <div class="bulk-body-table" v-if="bulk_coupon.show_message && bulk_coupon.show_message.show_type === 'table'">
      <h4 class="secondary_title">{{ bulk_coupon.show_message.table_title }}</h4>
      <el-table
        :data="bulk_coupon.discount_rule"
        :header-cell-style="{color:'#000000',background:'#F9F9F9'}"
        class="page_text_font"
        border
        style="width: 100%">
        <el-table-column
          :label="bulk_coupon.show_message.table_header"
        >
          <template slot-scope="scope">
            <span>{{ preference_type=='amount'? `${priceSymbol}${computePrice(scope.row.from,false,false,'auto')}` : scope.row.from}}+</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="bulk_coupon.show_message.table_discount"
        >
          <template slot-scope="scope">
            <div style="color:#DE4035;font-weight:bold">
              <span v-if="scope.row.type == 'flat'">{{`${priceSymbol}${computePrice(scope.row.value,false,false,'auto')}`}}</span>
              <span v-if="scope.row.type == 'percentage'">{{ scope.row.value }}%</span>
              OFF
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: [
    "bulk_coupon",
    "product_id",
    "variant_id",
    "cart_type",
    "product",
    "theme",
    "stock"
  ],
  data() {
    return {
      cartmes: {},
      cart_item: [], //购物车商品
      cart_contents_count: 0,
      has_num: 0, //购物车已有当前商品的数量
      disabled: false,
      click_index: null
    };
  },
  async beforeMount() {
    try {
      let res = await this.$axios.get(API.addcart);
      this.$store.dispatch("change_news_cart", res.data);
    } catch (error) {}
  },
  methods: {
    async addToCart(from, index) {
      this.disabled = true;
      this.click_index = index;
      try {
        let addproduct = {
          quantity: from - this.has_num,
          product_id: this.product_id,
          addType:"bulkCoupon"
        };
        if (this.variant_id) {
          addproduct.variant_id = this.variant_id;
        }
        let res = await this.$axios.post(API.addcart, addproduct);
        this.$store.dispatch("change_news_cart", res.data);
        if(res.data){
          this.$store.commit("change_button_disabled", true);
        }
        this.$store.dispatch("cartContentsCount", res.data.cart_contents_count);
        localStorage.setItem("cartContentsCount", res.data.cart_contents_count);
        if (this.theme == "Brooklyn" && this.cart_type == "drawer") {
          this.$store.dispatch("change_cart_type", true);
          this.disabled = false;
          this.$store.commit("change_button_disabled", false);
        } else if (this.theme == "showtime" && this.cart_type == "drawer") {
          this.disabled = false;
          this.$store.dispatch("change_button_disabled", false);
          document.body.scrollTop = document.documentElement.scrollTop = 0;
          this.$("#collapseExample").collapse("show");
        } else if ((this.theme == "showtime"||this.theme == "venue")&&this.cart_type == "popup") {
          this.disabled = false;
          this.$store.dispatch("change_button_disabled", false);
          this.$("#modalCart").modal("show");
        }else if(this.theme == "vogue"&&(this.cart_type == "drawer"||this.cart_type == "popup")){
            this.disabled = false;
            this.showInlineCart();
        } else if(this.theme == "athena"){
          this.$('.buy_animate').addClass('buy_animate_action');
          if(parseInt(this.$("#app").css("padding-left")) > 0) {
            this.$('.site-header').addClass('add_cart_animate_has_quicknav');
          }
          else {
            this.$('.site-header').addClass('add_cart_animate');
          }
        } else {
          if(this.theme !== 'Brooklyn'){
            window.open("/cart", "_self");
          }
        }
        if (window.fbq) {
          this.FbAddToCart(this.product, addproduct);
        }
        if(window._learnq){
          this.klaviyo_addtocart(this.product, addproduct)
        }
        if (window.snaptr) {
            window.snaptr('track', 'ADD_CART', {
              'currency': res.data.currency ? res.data.currency : "USD",
              'item_category': null,
              'item_ids': [this.product_id],
              'number_items':from - this.has_num,
              'price':this.product.sale_price*(from - this.has_num),
          })
        }
        setTimeout(() => {
          this.disabled = false;
          this.$store.commit("change_button_disabled", false);
        }, 800)
        // 谷歌分析，添加到购物车
        // todo 发送谷歌分析, 此处缺少详情数据
        googleAnalysis.event('add', {})
      } catch (error) {
        this.disabled = false;
        setTimeout(() => {
          this.$store.commit("change_button_disabled", false);
        }, 800)
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          this.$message.error(Object.values(error.response.data.errors)[0][0]);
        } else {
          this.$message.error(error?.response?.data?.message);
        }
      }
    },
    stepTip(item){
      const {discount_method,discount_order}=this.bulk_coupon;
      // discount_method 折扣方式 any(每层生效) top(最高级生效)
      // discount_order 折扣排序 asc desc
      let tip
      if(!discount_method) return
      switch (discount_method) {
        case 'top':
          if(discount_order == 'asc'){
             tip = this.$t('product.bulk_coupon_lower_price_step',{count:item.from,off:item.type == 'flat'?`${priceSymbol} ${ item.value }`:`${ item.value}%`})
             if(Number(item.from) != 1) tip =tip.replace(/item/,'items')
          } else {
             tip = this.$t('product.bulk_coupon_top_price_step',{count:item.from,off:item.type == 'flat'?`${priceSymbol} ${ item.value }`:`${ item.value}%`})
              if(Number(item.from) != 1) tip =tip.replace(/item/,'items')
          }
        break;

        default:
            tip = this.$t(`product.bulk_coupon_any_step_${item.from}`,{count:item.from,off:item.type == 'flat'?`${priceSymbol} ${ item.value }`:`${ item.value}%`})
          break;
      }
      return tip
      // console.log(this.bulk_coupon,'-----bulk_coupon',item)

    }
  },
  computed:{
    preference_type(){
      return this.bulk_coupon?.preference_type;
    },
    ...mapState({
      // 用户选择的货币符号
      priceSymbol: ({ priceSymbol }) => priceSymbol,
      mainButtonColor:({ options }) => options?.theme?.global?.colors?.button_primary_backgorund,
    }),
  },
  watch: {
    '$store.state.news_cart'(newV) {
      this.cartmes = newV
      this.cart_item = Object.values(newV.cart)
      this.has_num = 0
      let valid_cart_count = 0

      //   计算购物车已有当前商品的数量，加购时总是以目标数量减去当前商品数
      this.cart_item.forEach((cartitem) => {
        if (cartitem.wdr_free_product) return;
        if (cartitem.product_id == this.product_id) {
          this.has_num += cartitem.quantity
        }
        valid_cart_count += cartitem.quantity
      })
      //   如果购物车是所有都开启梯度优惠，则以购物车所有数量来显示不同梯度的button。若部分商品开启梯度优惠则以该商品的数量显示梯度优惠button
      if (this.bulk_coupon.product_ids.length == 0) {
        this.cart_contents_count = valid_cart_count
      } else {
        this.cart_contents_count = this.has_num
      }
    },
  },
//   components: {
//     elTable: Table,
//     elTableColumn: TableColumn
//   }
};
</script>
<style scoped lang='scss'>
.bulkcoupon {
  margin-top: 20px;
  width: 100%;
  text-align: left;
  h4 {
    color: #2f2f2f;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .bulkBody {
    border: 1px solid #E6E6E6;
    border-bottom: none;
    .couponItem {
      padding: 8px 20px;
      display: flex;
      border-bottom: 1px solid #E6E6E6;
      justify-content: space-between;
      align-items: center;
      .couponTips {
        h5 {
          margin: 0;
          font-size: 14px;
          line-height: 21px;
          font-weight: 600;
          text-align: left;
          color: #606060;
        }
        p {
          font-size: 12px;
          line-height: 21px;
          font-weight: 400;
          text-align: left;
          color: #bcbcbc;
          margin: 0;
        }
      }
      .couponButton {
        max-width: 45%;
        .addToCart {
          min-width: 110px;
          font-size: 13px;
          text-transform: none;
          letter-spacing: normal;
          text-align: center;
          border-radius: 2px;
          outline: 0;
          border: 1px solid transparent;
          transition: background-color 0.4s ease, border 0.4s ease;
          padding: 8px;
          line-height: 1;
        }
        button {
          font-weight: 400;
          background-color: #26a79a;
          color: #fff;
        }
        .button_active {
          border: 0px;
        }
        .soldout {
          background: #f6f6f6!important;
          border: 1px solid #DDDDDD!important;
          color: #DDDDDD;
        }

        & > div {
          font-weight: 600;
          background-color: #eee;
          color: #bcbcbc;
          pointer-events: none;
          span {
            font-weight: 600;
          }
        }
      }
    }
  }
}
.bulk-body-table {
  margin-top: 20px;
  h4 {
    text-align: center;
    margin-bottom: 20px;
  }
}
</style>
